/* eslint-disable */
import * as React from 'react';
import accessibilityOverscanIndicesGetter from './accessibilityOverscanIndicesGetter';
import { VirtualGrid } from './VirtualGrid';
import { css } from '@patternfly/react-styles';
class VirtualTableBody extends React.Component {
    constructor() {
        super(...arguments);
        this._cellRenderer = ({ parent, rowIndex, style, isScrolling, isVisible, key }) => {
            const { rowRenderer } = this.props;
            // TRICKY The style object is sometimes cached by VirtualGrid.
            // This prevents new style objects from bypassing shallowCompare().
            // However as of React 16, style props are auto-frozen (at least in dev mode)
            // Check to make sure we can still modify the style before proceeding.
            // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
            const { writable } = Object.getOwnPropertyDescriptor(style, 'width');
            if (writable) {
                // By default, List cells should be 100% width.
                // This prevents them from flowing under a scrollbar (if present).
                style.width = '100%';
            }
            return rowRenderer({
                index: rowIndex,
                style,
                isScrolling,
                isVisible,
                key,
                parent
            });
        };
        this._setRef = (ref) => {
            this.VirtualGrid = ref;
        };
        this._onScroll = ({ clientHeight, scrollHeight, scrollTop }) => {
            const { onScroll } = this.props;
            onScroll({ clientHeight, scrollHeight, scrollTop });
        };
        this._onSectionRendered = ({ rowOverscanStartIndex, rowOverscanStopIndex, rowStartIndex, rowStopIndex }) => {
            const { onRowsRendered } = this.props;
            onRowsRendered({
                overscanStartIndex: rowOverscanStartIndex,
                overscanStopIndex: rowOverscanStopIndex,
                startIndex: rowStartIndex,
                stopIndex: rowStopIndex
            });
        };
    }
    forceUpdateVirtualGrid() {
        if (this.VirtualGrid) {
            this.VirtualGrid.forceUpdate();
        }
    }
    /** See VirtualGrid#getOffsetForCell */
    getOffsetForRow({ alignment, index }) {
        if (this.VirtualGrid) {
            const { scrollTop } = this.VirtualGrid.getOffsetForCell({
                alignment,
                rowIndex: index,
                columnIndex: 0
            });
            return scrollTop;
        }
        return 0;
    }
    /** CellMeasurer compatibility */
    invalidateCellSizeAfterRender({ columnIndex, rowIndex }) {
        if (this.VirtualGrid) {
            this.VirtualGrid.invalidateCellSizeAfterRender({
                rowIndex,
                columnIndex
            });
        }
    }
    /** See VirtualGrid#measureAllCells */
    measureAllRows() {
        if (this.VirtualGrid) {
            this.VirtualGrid.measureAllCells();
        }
    }
    /** CellMeasurer compatibility */
    recomputeVirtualGridSize({ columnIndex = 0, rowIndex = 0 } = {}) {
        if (this.VirtualGrid) {
            this.VirtualGrid.recomputeVirtualGridSize({
                rowIndex,
                columnIndex
            });
        }
    }
    /** See VirtualGrid#recomputeVirtualGridSize */
    recomputeRowHeights(index = 0) {
        if (this.VirtualGrid) {
            this.VirtualGrid.recomputeVirtualGridSize({
                rowIndex: index,
                columnIndex: 0
            });
        }
    }
    /** See VirtualGrid#scrollToPosition */
    scrollToPosition(scrollTop = 0) {
        if (this.VirtualGrid) {
            this.VirtualGrid.scrollToPosition({ scrollTop });
        }
    }
    /** See VirtualGrid#scrollToCell */
    scrollToRow(index = 0) {
        if (this.VirtualGrid) {
            this.VirtualGrid.scrollToCell({
                columnIndex: 0,
                rowIndex: index
            });
        }
    }
    render() {
        const { className, noRowsRenderer, scrollToIndex, width, columns, columnCount, style, scrollContainerComponent, innerScrollContainerComponent } = this.props;
        const classNames = css('ReactVirtualized__List', className);
        return (
        // note: these aria props if rendered will break a11y for role="presentation"
        // this approach attempts to fix non standard table grids
        // see: https://www.html5accessibility.com/tests/aria-table-fix.html
        React.createElement(VirtualGrid, Object.assign({}, this.props, { style: Object.assign({ tableLayout: 'fixed', display: 'block' }, style), containerStyle: {
                display: 'block'
            }, "aria-label": null, "aria-readonly": null, tabIndex: null, autoContainerWidth: true, cellRenderer: this._cellRenderer, className: classNames, columnWidth: width, columnCount: columns ? columns.length : columnCount, noContentRenderer: noRowsRenderer, onScroll: this._onScroll, onSectionRendered: this._onSectionRendered, ref: this._setRef, scrollToRow: scrollToIndex, scrollContainerComponent: scrollContainerComponent, innerScrollContainerComponent: innerScrollContainerComponent })));
    }
}
VirtualTableBody.defaultProps = {
    autoHeight: false,
    estimatedRowSize: 30,
    onScroll: () => { },
    noRowsRenderer: () => null,
    onRowsRendered: () => { },
    overscanIndicesGetter: accessibilityOverscanIndicesGetter,
    overscanRowCount: 10,
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {},
    scrollContainerComponent: 'table',
    innerScrollContainerComponent: 'tbody'
};
export { VirtualTableBody };
//# sourceMappingURL=VirtualTableBody.js.map